import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  BuildIcon,
  DesignIcon,
  LaunchIcon,
  MaintenanceIcon,
  PlaneIcon,
  TestIcon,
} from "../../../app-constants";
const WorkFlow = [
  {
    logo: PlaneIcon,
    title: "Plan",
    description:
      "We use scrum methodologies to construct a path for development prioritizing items from the backlog.",
    count: "01",
  },
  {
    logo: DesignIcon,
    title: "Design",
    description:
      "We craft a solid blueprint for your game, mapping out the entire user experience including characters and gameplay.",
    count: "02",
  },
  {
    logo: BuildIcon,
    title: "Build",
    description:
      "Our Unity game developers transform the design into a functional application using the Unity Game Engine.",
    count: "03",
  },
  {
    logo: TestIcon,
    title: "Test",
    description:
      "To ensure your game app works properly, rigorous testing is conducted to identify and rectify any bugs.",
    count: "04",
  },
  {
    logo: LaunchIcon,
    title: "Launch",
    description:
      "Your Unity game app is ready to make its debut in various stores, reaching its intended audience.",
    count: "05",
  },
  {
    logo: MaintenanceIcon,
    title: "Maintenance",
    description:
      "We provide ongoing support and updates to keep your game app up-to-date and responsive to the needs.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 tekrevol_gray_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Our Game App Development <span>Workflow</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              As a leading Unity3D game development company, our game app
              development workflow is meticulously crafted to transform your
              ideas into immersive gaming realities. Here is TekRevol’s game app
              development workflow: 
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
